import { ID_NUMBERS_WITNESSES } from 'civil-status/components/step/form/last-step/accordions/section/list/list-number';
import { CodeSubject } from 'civil-status/constants/code-subject-section';
import { ConfigurationType } from 'civil-status/constants/configuration-type';
import { ID_APPLICANT } from 'civil-status/constants/id-applicant';
import { GenitoreTrasmessoCittadinanaza } from 'civil-status/constants/id-genitore-trasmesso-cittadinanaza';
import { IDMinorAssistance } from 'civil-status/constants/id-minor-assistance';
import { ParentChangedSurnameID } from 'civil-status/constants/id-parent-changed-surname';
import { RiconoscimentoGenitoreItaliano } from 'civil-status/constants/id-riconoscimento-genitore-italiano';
import { IDSentenceRecognition } from 'civil-status/constants/id-sentence-recognition';
import { ID_TYPE_APPLICANT } from 'civil-status/constants/id-type-applicant';
import { keyAllHolders } from 'civil-status/constants/key-all-holders';
import { typePresence } from 'civil-status/constants/type-presence';
import { ParentVM, SectionVM } from 'civil-status/view-models/step-form';
import { CivilStatusID } from 'shell/constants/civil-status';
import { SubjectsWizardUseCase } from 'shell/models/subjects-wizard';
import { numberCondition } from './numbers-condition';
import { keyAllChildren } from 'civil-status/constants/key-all-children';

export const subjectIsVisibility = (
  itemSubject?: SubjectsWizardUseCase | ParentVM,
  isWithInterprete = false,
  isWith1Comparente = false,
  isWith2Comparente = false,
  isWithDeceduto?: boolean,
  valuesDeceduto?: ParentVM,
  valuesDatiTrascrizione?: SectionVM,
  valuesGenitoreTrasmetteCittadinanza?: SectionVM,
  valuesDatiSpecificiCittadinanza?: SectionVM,
  valuesRicGenitoreItaliano?: SectionVM,
  valuesDatiGeneraliConsenso?: SectionVM,
  valuesIntNas?: ParentVM,
  valuesSpecificCivilUnionMarriage?: SectionVM,
  valuesDatiSepar?: SectionVM,
  valuesIntest1?: ParentVM
): boolean => {
  const presenza: string =
    (itemSubject as SubjectsWizardUseCase)?.presenza || (itemSubject as ParentVM)?.presenza || '';

  if (
    presenza === typePresence.Obbligatorio ||
    presenza === typePresence.Facoltativo ||
    presenza === typePresence.FacoltativoObbligatorio ||
    presenza === typePresence.Default1
  ) {
    // se la sezione è obbligatoria, facoltativa, FacoltativoObbligatorio o D1 mostrare sempre
    return true;
  }

  // Estrai il codice del soggetto e la configurazione
  const codeSubject: string =
    (itemSubject as SubjectsWizardUseCase)?.codSoggetto ||
    (itemSubject as ParentVM)?.codeSubject ||
    '';
  const configuration: string =
    (itemSubject as SubjectsWizardUseCase)?.configurazione ||
    (itemSubject as ParentVM)?.configuration ||
    '';

  // Verifica se il soggetto corrente è il Comparente 1
  const isComparente1 = codeSubject === CodeSubject.COMPARENTE1;

  if (isComparente1) {
    // Se Comparente 1 è presente, mostra se almeno un Comparente è presente
    return isWith1Comparente || isWith2Comparente;
  }

  // Verifica se il soggetto corrente è il Comparente 2
  const isComparente2 = codeSubject === CodeSubject.COMPARENTE2;

  if (isComparente2) {
    // Se Comparente 2 è presente, mostra solo se Comparente 2 è presente
    return isWith2Comparente;
  }

  // Verifica se il soggetto corrente è il Coniuge
  if (codeSubject === CodeSubject.CONIUGE && (isWithDeceduto || valuesIntNas)) {
    // Se il Coniuge è presente e c'è il Deceduto, mostra solo se il Coniuge è coniugato o vedovo
    return (
      valuesDeceduto?.generality?.civilStatusItem?.id?.toString() === CivilStatusID.coniugato ||
      valuesDeceduto?.generality?.civilStatusItem?.id?.toString() === CivilStatusID.vedovo ||
      valuesIntNas?.generality?.civilStatusItem?.id?.toString() === CivilStatusID.coniugato ||
      valuesIntNas?.generality?.civilStatusItem?.id?.toString() === CivilStatusID.vedovo
    );
  }

  // Verifica se il soggetto corrente è unito civilmente
  if (codeSubject === CodeSubject.UNITOCIVILMENTE) {
    // Se il soggetto è unito civilmente, mostra solo se è unito civilmente o ha sciolto l'unione civilmente a seguito del decesso
    return (
      valuesDeceduto?.generality?.civilStatusItem?.id?.toString() ===
        CivilStatusID.unitoCivilmente ||
      valuesDeceduto?.generality?.civilStatusItem?.id?.toString() ===
        CivilStatusID.scioglimentoUnitoCivilmenteASeguitoDelDecesso ||
      valuesIntNas?.generality?.civilStatusItem?.id?.toString() === CivilStatusID.unitoCivilmente ||
      valuesIntNas?.generality?.civilStatusItem?.id?.toString() ===
        CivilStatusID.scioglimentoUnitoCivilmenteASeguitoDelDecesso
    );
  }

  if (codeSubject === CodeSubject.INTERPR) {
    // Se il soggetto è un interprete, mostra solo se uno dei valori associati ha un interprete
    return isWithInterprete;
  }

  if (configuration === ConfigurationType.RIC4) {
    // Se la configurazione è Ric4, mostra solo se il richiedente corrente è associato al trascrizione
    return valuesDatiTrascrizione?.applicant?.id === ID_APPLICANT.ALTRO;
  }

  // Verifica se la configurazione corrente è Ric5
  if (configuration === ConfigurationType.RIC5) {
    // Se la configurazione è Ric5, mostra solo se il richiedente corrente è associato al trascrizione
    return (
      valuesDatiTrascrizione?.applicant?.id === ID_APPLICANT.PADRE ||
      valuesDatiTrascrizione?.applicant?.id === ID_APPLICANT.MADRE_PADRE
    );
  }

  // Verifica se la configurazione corrente è Ric6
  if (configuration === ConfigurationType.RIC6) {
    // Se la configurazione è Ric6, mostra solo se il richiedente corrente è associato al trascrizione
    return (
      valuesDatiTrascrizione?.applicant?.id === ID_APPLICANT.MADRE ||
      valuesDatiTrascrizione?.applicant?.id === ID_APPLICANT.MADRE_PADRE
    );
  }

  // Verifica se la configurazione corrente è Ric7
  if (configuration === ConfigurationType.RIC7) {
    // Se la configurazione è Ric7, mostra solo se il richiedente corrente è associato al trascrizione
    return valuesDatiTrascrizione?.applicant?.id === ID_APPLICANT.SOGGETTO;
  }

  if (
    codeSubject === CodeSubject.PADRE &&
    (valuesGenitoreTrasmetteCittadinanza ||
      valuesDatiSpecificiCittadinanza ||
      valuesRicGenitoreItaliano ||
      valuesDatiGeneraliConsenso ||
      valuesDatiTrascrizione)
  ) {
    // Se il soggetto è il padre e ci sono di dati di valuesGenitoreTrasmetteCittadinanza o valuesDatiSpecificiCittadinanza o valuesRicGenitoreItaliano, mostra solo in questo caso
    return Boolean(
      valuesGenitoreTrasmetteCittadinanza?.parentTransmittedCitizenship ===
        GenitoreTrasmessoCittadinanaza.trasmissione2 ||
        valuesGenitoreTrasmetteCittadinanza?.parentTransmittedCitizenship ===
          GenitoreTrasmessoCittadinanaza.trasmissione3 ||
        valuesDatiSpecificiCittadinanza?.sentenceRecognition ===
          IDSentenceRecognition.Riconoscimento2 ||
        valuesDatiSpecificiCittadinanza?.sentenceRecognition ===
          IDSentenceRecognition.Riconoscimento3 ||
        valuesDatiTrascrizione?.parentRecognition === RiconoscimentoGenitoreItaliano.Padre ||
        valuesDatiTrascrizione?.parentRecognition === RiconoscimentoGenitoreItaliano.Entrambi ||
        valuesDatiTrascrizione?.sentenceRecognition === IDSentenceRecognition.Riconoscimento2 ||
        valuesRicGenitoreItaliano?.parentRecognition === RiconoscimentoGenitoreItaliano.Padre ||
        valuesDatiGeneraliConsenso?.parentRecognition === RiconoscimentoGenitoreItaliano.Padre ||
        valuesDatiGeneraliConsenso?.parentRecognition === RiconoscimentoGenitoreItaliano.Entrambi ||
        valuesDatiTrascrizione?.applicant?.id === ID_APPLICANT.PADRE ||
        valuesDatiTrascrizione?.applicant?.id === ID_APPLICANT.MADRE_PADRE ||
        valuesDatiTrascrizione?.parentChangedSurname === ParentChangedSurnameID.Padre
    );
  }

  if (
    codeSubject === CodeSubject.MADRE &&
    (valuesGenitoreTrasmetteCittadinanza ||
      valuesDatiSpecificiCittadinanza ||
      valuesRicGenitoreItaliano ||
      valuesDatiGeneraliConsenso ||
      valuesDatiTrascrizione)
  ) {
    // Se il soggetto è la madre e ci sono di dati di valuesGenitoreTrasmetteCittadinanza o valuesDatiSpecificiCittadinanza o valuesRicGenitoreItaliano, mostra solo in questo caso
    return Boolean(
      valuesGenitoreTrasmetteCittadinanza?.parentTransmittedCitizenship ===
        GenitoreTrasmessoCittadinanaza.trasmissione1 ||
        valuesGenitoreTrasmetteCittadinanza?.parentTransmittedCitizenship ===
          GenitoreTrasmessoCittadinanaza.trasmissione3 ||
        valuesDatiSpecificiCittadinanza?.sentenceRecognition ===
          IDSentenceRecognition.Riconoscimento1 ||
        valuesDatiSpecificiCittadinanza?.sentenceRecognition ===
          IDSentenceRecognition.Riconoscimento4 ||
        valuesDatiTrascrizione?.parentRecognition === RiconoscimentoGenitoreItaliano.Madre ||
        valuesDatiTrascrizione?.parentRecognition === RiconoscimentoGenitoreItaliano.Entrambi ||
        valuesDatiTrascrizione?.sentenceRecognition === IDSentenceRecognition.Riconoscimento1 ||
        valuesRicGenitoreItaliano?.parentRecognition === RiconoscimentoGenitoreItaliano.Madre ||
        valuesDatiGeneraliConsenso?.parentRecognition === RiconoscimentoGenitoreItaliano.Madre ||
        valuesDatiGeneraliConsenso?.parentRecognition === RiconoscimentoGenitoreItaliano.Entrambi ||
        valuesDatiTrascrizione?.applicant?.id === ID_APPLICANT.MADRE ||
        valuesDatiTrascrizione?.applicant?.id === ID_APPLICANT.MADRE_PADRE ||
        valuesDatiTrascrizione?.parentChangedSurname === ParentChangedSurnameID.Madre
    );
  }

  if (codeSubject === CodeSubject.RICHIEDENTE && (valuesDatiSepar || valuesDatiTrascrizione)) {
    return (
      Boolean(valuesDatiSepar && valuesDatiSepar?.isReceivedPrivateCitizen) ||
      Boolean(
        valuesDatiTrascrizione && valuesDatiTrascrizione?.applicant?.id === ID_APPLICANT.ALTRO
      )
    );
  }

  if (codeSubject === CodeSubject.RICHIEDENTE_PRIVATO && valuesDatiTrascrizione) {
    return valuesDatiTrascrizione?.typeApplicant === ID_TYPE_APPLICANT.Privato;
  }

  if (codeSubject === CodeSubject.TESTIMONE3) {
    return (
      valuesSpecificCivilUnionMarriage?.numberWitnesses === ID_NUMBERS_WITNESSES.ID_3 ||
      valuesSpecificCivilUnionMarriage?.numberWitnesses === ID_NUMBERS_WITNESSES.ID_4
    );
  }

  if (codeSubject === CodeSubject.TESTIMONE4) {
    return valuesSpecificCivilUnionMarriage?.numberWitnesses === ID_NUMBERS_WITNESSES.ID_4;
  }

  if (codeSubject === CodeSubject.PADRESPOSO) {
    return (
      valuesSpecificCivilUnionMarriage?.minorGroomAssistance === IDMinorAssistance.Padre ||
      valuesSpecificCivilUnionMarriage?.minorGroomAssistance === IDMinorAssistance.Entrambi
    );
  }

  if (codeSubject === CodeSubject.MADRESPOSO) {
    return (
      valuesSpecificCivilUnionMarriage?.minorGroomAssistance === IDMinorAssistance.Madre ||
      valuesSpecificCivilUnionMarriage?.minorGroomAssistance === IDMinorAssistance.Entrambi
    );
  }

  if (codeSubject === CodeSubject.TUTORESPOSO) {
    return valuesSpecificCivilUnionMarriage?.minorGroomAssistance === IDMinorAssistance.Tutore;
  }

  if (codeSubject === CodeSubject.CURATORESPOSO) {
    return valuesSpecificCivilUnionMarriage?.minorGroomAssistance === IDMinorAssistance.Curatore;
  }

  if (codeSubject === CodeSubject.PADRESPOSA) {
    return (
      valuesSpecificCivilUnionMarriage?.minorWifeAssistance === IDMinorAssistance.Padre ||
      valuesSpecificCivilUnionMarriage?.minorWifeAssistance === IDMinorAssistance.Entrambi
    );
  }

  if (codeSubject === CodeSubject.MADRESPOSA) {
    return (
      valuesSpecificCivilUnionMarriage?.minorWifeAssistance === IDMinorAssistance.Madre ||
      valuesSpecificCivilUnionMarriage?.minorWifeAssistance === IDMinorAssistance.Entrambi
    );
  }

  if (codeSubject === CodeSubject.TUTORESPOSA) {
    return valuesSpecificCivilUnionMarriage?.minorWifeAssistance === IDMinorAssistance.Tutore;
  }

  if (codeSubject === CodeSubject.CURATORESPOSA) {
    return valuesSpecificCivilUnionMarriage?.minorWifeAssistance === IDMinorAssistance.Curatore;
  }

  if (
    codeSubject === CodeSubject.AVVOC1 ||
    codeSubject === CodeSubject.AVVOC3 ||
    codeSubject === CodeSubject.AVVOCUC1
  ) {
    return (valuesDatiSepar && valuesDatiSepar.isLawyerHusband) || false;
  }

  if (codeSubject === CodeSubject.AVVOC5) {
    return (valuesDatiSepar && valuesDatiSepar.isLawyerHusbandWife) || false;
  }

  if (
    codeSubject === CodeSubject.AVVOC2 ||
    codeSubject === CodeSubject.AVVOC4 ||
    codeSubject === CodeSubject.AVVOCUC2
  ) {
    return (valuesDatiSepar && valuesDatiSepar.isLawyerWife) || false;
  }

  if (codeSubject === CodeSubject.INTEST2) {
    return valuesIntest1?.generality?.isChangeSurnameName || false;
  }

  // INT_NAS_*
  if (keyAllHolders.includes(codeSubject as CodeSubject)) {
    return (numberCondition(valuesDatiTrascrizione?.numberHolders) || []).includes(codeSubject);
  }

  // FIGLIO_*
  if (keyAllChildren.includes(codeSubject as CodeSubject)) {
    return (numberCondition(valuesDatiTrascrizione?.numberChildren, true) || []).includes(
      codeSubject
    );
  }

  // Mostra il soggetto per default
  return true;
};
